// extracted by mini-css-extract-plugin
export default {"heading3":"Heading3_heading3__Vcs4a"};